import React from "react";
import CourseProgramCards from "../../Home/CourseProgramCards";

const ComputerSciencePrograms = [
  {
    id: 1,
    image: "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?auto=format&fit=crop&w=2072&q=80",
    heading: "Programming Fundamentals",
    introduction: "Learn the basics of programming languages and software development.",
    buttonText: "LEARN MORE",
    route: "programming-fundamentals",
  },
  {
    id: 2,
    image: "https://images.unsplash.com/photo-1555949963-aa79dcee981c?auto=format&fit=crop&w=2072&q=80",
    heading: "Data Structures & Algorithms",
    introduction: "Master fundamental data structures and algorithmic problem solving.",
    buttonText: "LEARN MORE",
    route: "data-structures-algorithms",
  },
  {
    id: 3,
    image: "https://images.unsplash.com/photo-1461749280684-dccba630e2f6?auto=format&fit=crop&w=2072&q=80",
    heading: "Software Engineering",
    introduction: "Learn software development methodologies and best practices.",
    buttonText: "LEARN MORE",
    route: "software-engineering",
  },
  {
    id: 4,
    image: "https://images.unsplash.com/photo-1544383835-bda2bc66a55d?auto=format&fit=crop&w=2072&q=80",
    heading: "Database Systems",
    introduction: "Design and implement database systems for applications.",
    buttonText: "LEARN MORE",
    route: "database-systems",
  },
  {
    id: 5,
    image: "https://images.unsplash.com/photo-1677442136019-21780ecad995?auto=format&fit=crop&w=2072&q=80",
    heading: "Artificial Intelligence",
    introduction: "Explore AI concepts, machine learning, and intelligent systems.",
    buttonText: "LEARN MORE",
    route: "artificial-intelligence",
  },
  {
    id: 6,
    image: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?auto=format&fit=crop&w=2072&q=80",
    heading: "Computer Networks",
    introduction: "Understand network protocols, architecture, and communication.",
    buttonText: "LEARN MORE",
    route: "computer-networks",
  },
];

const ComputerScienceProgramsCard = () => {
  return (
    <div className="flex justify-center space-x-0">
      <CourseProgramCards
        programs={ComputerSciencePrograms}
        basePath="/courses/computer-science"
      />
    </div>
  );
};

export default ComputerScienceProgramsCard;
